import * as React from 'react'

function SvgRu(props) {
	return (
		<svg viewBox="0 0 9 6" width="1em" height="1em" {...props}>
			<path fill="#fff" d="M0 0h9v3H0z" />
			<path fill="#d52b1e" d="M0 3h9v3H0z" />
			<path fill="#0039a6" d="M0 2h9v2H0z" />
		</svg>
	)
}

export default SvgRu
